Auth = require 'app/scripts/db/auth'
MemberOnBoardView = require 'app/scripts/views/member-menu-profile/member-on-board-view'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
template = require 'app/scripts/views/templates/invitee-orientation'
idToDate = require('app/common/lib/util/date').idToDate
{ truncate } = require 'app/common/lib/util/text/truncate'
_ = require 'underscore'

FACEPILE_MAX_VISIBLE = 3

module.exports = class InviteeOrientationView extends View
  className: 'invitee-orientation-wrapper'

  events:
    'click .js-close-orientation': 'onClose'

  initialize: ->
    # This view can only be rendered once, as re-rendering would run the
    # animations again. It's safe to only render once because the information
    # here is static - we do not depend on api requests or websocket messages.
    @hasRendered = false

  getInviteToken: ->
    Util.inviteTokenFor(@model.id)

  getMemberForAvatar: ->
    inviteToken = @getInviteToken()
    idInviter = inviteToken.split('-')[1]
    avatarMember = @modelCache.get('Member', idInviter)

    if !avatarMember?
      avatarMember = @model.adminList.models[0]

    avatarMember

  renderableMembers: ->
    renderableMembers = @model.orderedVisibleMembers().slice(0, FACEPILE_MAX_VISIBLE)

    if Auth.isLoggedIn()
      # In all other facepiles, the currently-logged-in member is always first,
      # but here they don't want to be first, they want to see everyone else
      # that's on the board - that's the point of this feature. Put them last.
      me = renderableMembers.shift()
      renderableMembers.push(me)

    renderableMembers

  shouldSeePopover: ->
    # you should see the popover if:
    # 1) you are logged in
    Auth.isLoggedIn() &&
    # 2) you haven't dismissed the popover before
    !Auth.me().isDismissed('invitee-orientation') &&
    # 3) you have an invite token for this board
    @getInviteToken() &&
    # 4) your account is newer than the threshold
    idToDate(Auth.myId()) >= new Date("2019-06-15")

  renderFacepile: ->
    subviews = for member in @renderableMembers()
      @subview MemberOnBoardView, member,
        board: @model
        notClickable: true
        small: true
        hideBadges: true

    @ensureSubviews(subviews.reverse(), @$('.js-invitee-orientation-facepile'))

  _getDataForMessage: ->
    allVisibleMembers = @model.orderedVisibleMembers()
    renderableMembers = @renderableMembers()

    visibleMembersCount: allVisibleMembers.length
    maxVisible: FACEPILE_MAX_VISIBLE
    firstMemberFullName: truncate(renderableMembers[0].get('fullName'), 30)
    boardName: @model.get('name')

  _getDataForAvatar: ->
    inviterAvatarUrl: @getMemberForAvatar().get('avatarUrl')
    inviterFullName: @getMemberForAvatar().getMemberViewTitle()
    inviterUsername: @getMemberForAvatar().get('username')
    inviterInitials: @getMemberForAvatar().get('initials')

  render: ->
    if !@shouldSeePopover() || @hasRendered
      return @

    data = {}
    data = _.extend(data, @_getDataForAvatar())
    data = _.extend(data, @_getDataForMessage())

    @$el.html(template(data))
    @renderFacepile()

    $messageContainer = @$el.find('.invitee-orientation-message-container')
    $avatarContainer = @$el.find('.invitee-orientation-avatar-container')
    setTimeout (=>$avatarContainer.addClass('active')), 1200
    setTimeout (=>$messageContainer.addClass('active')), 1350

    @hasRendered = true

    @

  onClose: ->
    Auth.me().dismiss('invitee-orientation')
    @remove()
